import { render, staticRenderFns } from "./FileUploaderImg.vue?vue&type=template&id=129460f0&scoped=true"
import script from "./FileUploaderImg.vue?vue&type=script&lang=js"
export * from "./FileUploaderImg.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderImg.vue?vue&type=style&index=0&id=129460f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129460f0",
  null
  
)

export default component.exports